import { Link } from "react-router-dom";
import styles from "../styles/pages.module.css";

export default function MudanzasMadridCentro() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Mudanzas en Madrid Centro</h1>
        <span className={styles.lastUpdated}>Mudanzas profesionales en el corazón de Madrid</span>

        <div style={{ textAlign: "center", margin: "1.5rem 0" }}>
          <img
            src="/assets/images/distrito-madrid.webp"
            alt="Mudanzas en Madrid Centro"
            style={{ maxWidth: "100%", borderRadius: "8px", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}
          />
        </div>

        <p>
          Mudarse en <strong>Madrid Centro</strong> tiene sus particularidades: calles estrechas, edificios históricos sin ascensor, zonas de carga reguladas y un tráfico intenso que requiere planificación quirúrgica. En Britosa Mudanzas llevamos más de dos décadas dominando cada uno de estos desafíos.
        </p>

        <h2>Expertos en mudanzas urbanas en Madrid</h2>
        <p>
          Desde Malasaña hasta Lavapiés, pasando por Gran Vía, Sol y La Latina, nuestro equipo conoce las restricciones de tráfico, los horarios de carga/descarga y las peculiaridades de los edificios centenarios de la capital. Si vives en una quinta sin ascensor o en una calle peatonal, tenemos la solución: montacargas portátil, equipos de porteo especializado y vehículos de diferentes tamaños para adaptarnos a cualquier acceso.
        </p>

        <h2>Servicios disponibles en Madrid Centro</h2>
        <ul>
          <li><strong>Mudanzas express:</strong> Ideal para estudiantes y pisos pequeños. En el mismo día.</li>
          <li><strong>Mudanzas con montacargas:</strong> Para alturas sin ascensor o con muebles de gran volumen.</li>
          <li><strong>Mudanzas de oficinas:</strong> Despachos en azoteas, coworkings y edificios de negocios.</li>
          <li><strong>Guardamuebles temporal:</strong> Si necesitas almacenar tus pertenencias entre mudanzas.</li>
          <li><strong>Embalaje integral:</strong> Nos ocupamos de proteger cada objeto como si fuera nuestro.</li>
        </ul>

        <h2>Barrios del centro donde operamos</h2>
        <p>
          Sol, Malasaña, Chueca, La Latina, Lavapiés, Ópera, Palacio, Las Letras, Atocha, Chueca, Justicia, Universidad, Tribunal y todos los barrios de los distritos Centro, Retiro, Chamberí, Salamanca y Arganzuela.
        </p>

        <div style={{ background: "#f0f9ff", borderRadius: "8px", padding: "1.25rem", margin: "1.5rem 0", border: "1px solid #bae6fd" }}>
          <h3 style={{ marginTop: 0, color: "#0F4C75" }}>Presupuesto para tu mudanza en Madrid Centro</h3>
          <p style={{ marginBottom: "1rem" }}>
            Cada mudanza en el centro es diferente. Cuéntanos tu caso y te preparamos un presupuesto a medida en menos de 24h.
          </p>
          <Link to="/presupuesto" style={{ display: "inline-block", padding: "0.6rem 1.4rem", background: "#F97316", color: "#fff", borderRadius: "6px", textDecoration: "none", fontWeight: 600 }}>
            Pedir presupuesto →
          </Link>
        </div>

        <p style={{ fontSize: "0.85rem", color: "#6b7280", marginTop: "2rem" }}>
          Llámanos al <a href="tel:+34691604880">691 60 48 80</a> · Disponibles todos los días de 8:00 a 22:00.
        </p>
      </div>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Britosa Mudanzas - Madrid Centro",
          "description": "Mudanzas profesionales en Madrid Centro. Expertos en mudanzas urbanas, calles estrechas y edificios sin ascensor.",
          "url": "https://mudanzasbritosa.com/mudanzas-madrid-centro",
          "telephone": "+34691604880",
          "email": "info@mudanzasbritosa.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "C. Río Duero, 28934 Móstoles",
            "addressLocality": "Madrid",
            "addressRegion": "Madrid",
            "addressCountry": "ES"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.4168,
            "longitude": -3.7038
          },
          "areaServed": {
            "@type": "City",
            "name": "Madrid"
          },
          "priceRange": "€€",
          "openingHours": "Mo-Su 08:00-22:00"
        })
      }} />
    </div>
  );


}
